let currency_convert_auto = false;
let currency_convert_no_currency_code = false;
let currency_convert_interval_count = 0;
let currency_convert_interval = setInterval(() => {
  if (document.querySelector(".pick_currency .nice-select .list")) {
    clearInterval(currency_convert_interval);
    startCurrencyAutoConvert();
  } else {
    currency_convert_interval_count++;
    if (currency_convert_interval_count > 600) {
      clearInterval(currency_convert_interval);
    }
  }
}, 100)

function formatCurrency(value, currency) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(value);
}

function currencyConvertFastSimonSerpApp() {
  const FS = document.querySelector("#fast-simon-serp-app");
  if (!FS || !FS.shadowRoot) { return; }

  const selectors = [".fs-serp-price .price", ".compare-container .fs-compare"];
  const currentCurrency = window.ACSCurrency.currentCurrency;

  selectors.forEach(selector => {
    const prices = FS.shadowRoot.querySelectorAll(selector);
    prices.forEach(price => {
      let fromCurrency = price.dataset.currency || currencyConvertGetCurrencyFromPrice(price.textContent) || "USD";

      let value = price.textContent.replace(/[^\d.-]/g, '');
      if (value.startsWith(".")) value = value.slice(1);
      if (fromCurrency === "JPY" && price.textContent.includes("Y円")) {
        value = value.charAt(value.length - 1) + value.slice(0, -1);
      }
      value = window.ACSCurrency.convert(parseFloat(value), fromCurrency, currentCurrency).toFixed(2);

      price.innerHTML = formatCurrency(value, currentCurrency).replace(currentCurrency, "").trim();
      price.dataset.currency = currentCurrency;
    });
  });
}

function currencyConvertFastSimonUpsell() {
  const FS = document.querySelectorAll(".fast-simon-upsell"); //:not(.cart-upsel)
  if (!FS) { return; }

  const currentCurrency = window.ACSCurrency.currentCurrency;

  FS.forEach(upsell => {
    if (!upsell.shadowRoot) { return; }

    const prices = upsell.shadowRoot.querySelectorAll(".fs-recommendation-product-price");
    const defaultFromCurrency = upsell.classList.contains("cart-upsel") ? currentCurrency : "USD";

    prices.forEach(price => {
      let fromCurrency = defaultFromCurrency;
      if (price.dataset.currency) {
        fromCurrency = price.dataset.currency;
      } else {
        let currency = currencyConvertGetCurrencyFromPrice(price.textContent);
        if (currency) {
          fromCurrency = currency;
        }
      }

      const previousPrice = price.querySelector(".previous-price");
      if (previousPrice) {
        let values = price.innerText.replace(/[^\d\s.-]/g, '').replace(/\.\s/g, "").replace(/^\s+/g, "").split(/\s+/g);
        /*if (upsell.classList.contains("cart-upsel")) {
          console.log(values)
        }*/
        if (values.length != 2) {
          return;
        }
        if (values[0].startsWith(".")) {
          values[0] = values[0].slice(1);
        }
        if (values[1].startsWith(".")) {
          values[1] = values[1].slice(1);
        }
        values[0] = window.ACSCurrency.convert(values[0], fromCurrency, currentCurrency).toFixed(2);
        values[1] = window.ACSCurrency.convert(values[1], fromCurrency, currentCurrency).toFixed(2)
        price.innerHTML = currencyConvertFormat(values[0], currentCurrency).replace(currentCurrency, "") + " \n";
        previousPrice.innerHTML = currencyConvertFormat(values[1], currentCurrency).replace(currentCurrency, "");
        price.appendChild(previousPrice);
      } else {
        let value = price.textContent.replace(/[^\d.-]/g, '');
        if (value.startsWith(".")) {
          value = value.slice(1);
        }
        value = window.ACSCurrency.convert(value, fromCurrency, currentCurrency).toFixed(2);
        price.innerHTML = currencyConvertFormat(value, currentCurrency).replace(currentCurrency, "");
      }
      price.dataset.currency = currentCurrency;
    });

  });
}

function currencyConvertGetCurrencyFromPrice(price) {
  const price_letters = price.replace(/[^a-zA-Z]/g, '');
  if (price_letters.length != 3) {
    if (price.includes("₹")) {
      return "INR";
    }
    if (price.includes("€")) {
      return "EUR";
    }
    if (price.includes("£")) {
      return "GBP";
    }
    if (price.includes("円")) {
      return "JPY";
    }
  } else {
    const currencies = Object.keys(window.ACSCurrency.moneyFormats);
    if (currencies.includes(price_letters)) {
      return price_letters;
    }
  }

  switch (price_letters) {
    case "sR": return "INR";
    case "Y": return "JPY";
    case "KH":
    case "HK": return "HKD";
  }
  return false;
}

function currencyConvertFormat(value, currency) {
  const currencies = window.ACSCurrency.moneyFormats;
  const format = currencies[currency].money_with_currency_format;
  if (format.includes("amount_with_comma_separator")) {
    return currencies[currency].money_with_currency_format.replace("{{amount_with_comma_separator}}", value)
  }
  if (format.includes("amount_no_decimals")) {
    return currencies[currency].money_with_currency_format.replace("{{amount_no_decimals}}", parseFloat(value).toFixed(0))
  }
  return currencies[currency].money_with_currency_format.replace("{{amount}}", value);
}

function currencyConvertRemoveCurrencyCode() {
  const currentCurrency = window.ACSCurrency.currentCurrency;
  const moneys = document.querySelectorAll("span.money");
  moneys.forEach(money => {
    money.innerText = money.innerText.replace(currentCurrency, "");
  });
}

function InitialCurrency(currency) {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie_name = cookies[i].split("=")[0].replace(/^\s+/, "");
    if (cookie_name == "acscurrency") {
      return;
    }
  }
  document.cookie = `acscurrency=${currency}; path=/; domain=.${location.host}`;

  const spans = document.querySelectorAll(".pick_currency .mlcurrent");
  spans.forEach((span) => {
    span.textContent = currency;
  });

  const selected = document.querySelectorAll('.pick_currency li.selected');
  selected.forEach((li) => {
    li.classList.remove("selected");
  })

  const toSelect = document.querySelectorAll(`.pick_currency li[data-value=${currency}]`);
  toSelect.forEach((li) => {
    li.classList.add("selected");
  })
}

function startCurrencyAutoConvert() {
  //InitialCurrency("USD");
  if (!currency_convert_auto) {
    currency_convert_auto = setInterval(() => {
      currencyConvertFastSimonSerpApp();
      currencyConvertFastSimonUpsell();
    }, 333);
    currency_convert_no_currency_code = setInterval(() => {
      currencyConvertRemoveCurrencyCode();
    }, 10);
  }
}